import { render, staticRenderFns } from "./GpTabsContent.vue?vue&type=template&id=5a988f74&"
import script from "./GpTabsContent.vue?vue&type=script&lang=js&"
export * from "./GpTabsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports